import { IMsisdn } from "../../IPortinForm";
import { validateMobileNumberPortRoute } from "../../../../ApiRoutes";

export const validateMobileNumber = (
    phoneNumber: string,
    setErrorMessage: (errorMessage: string) => void
): Promise<IMsisdn | undefined> =>
    fetch(validateMobileNumberPortRoute(phoneNumber), {
        method: "GET",
    })
        .then((response) => response.json())
        .then((result) => {
            if (result?.errorMessage) {
                setErrorMessage(result.errorMessage);

                return undefined;
            }

            return result;
        });
